import React, { useState } from 'react';
import { FaTag } from 'react-icons/fa';
import { useFindCouponQuery } from '../../features/api/apiSlice';
import { useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import { useEffect } from 'react';

const Coupon = () => {
    const [inputCoupon, setInputCoupon] = useState('');
    const {
        data: coupon,
        // isLoading,
        // isError
    } = useFindCouponQuery(inputCoupon, { skip: !inputCoupon });
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = data => {
        setInputCoupon(data?.code)
    };


    
    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);

    return (
        <div>
            <div className="title-div flex content-center gap-1">
                <div className="grid content-center">
                    <FaTag className='text-xl text-bnd-1' />
                </div>
                <h3 className='text-lg font-medium text-gray-500 font-poppins'>{translate ? "Discount Codes" : "ডিসকাউন্ট কোড"} </h3>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='gap-2 w-full grid grid-cols-3 grid-rows-1'>
                    <div className='col-span-2'>
                        <div>
                            <label className="block text-md font-normal text-gray-600 mb-0">
                                {translate ? "Coupon Code" : "কুপন কোড"}
                            </label>
                            <input
                                type="text"
                                className="w-full border border-gray-800 rounded h-9  focus:outline-offset-2  outline-blue-500/50 px-2 py-2 text-gray-600"
                                {...register("code", { required: true })}
                            />
                        </div>
                    </div>
                    <div className='grid content-end'>
                        <button type="submit" className='dk text-white rounded px-3 py-1.5 bg-bnd-1'>{translate ? "Apply" : "আবেদন"}</button>
                    </div>
                </div>
                {errors.exampleRequired && <span>This field is required</span>}
            </form>
        </div>
    );
};

export default Coupon;